import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { ArrowDropDownIcon } from 'components/SvgIcon.jsx';

const SelectStyles = ['default', 'alternative'];
const SelectSizes = ['small', 'medium', 'big'];

const TdtSelect = ({
    className,
    selectStyle = 'default',
    selectSize = 'medium',
    children,
    suffixIcon,
    dropdownRender,
    notFoundContent = null,
    dropdownSuffix,
    dropdownClassName,
    open,
    onDropdownVisibleChange,
    dropdownInnerStyle,
    dropdownAutoWidth = true,
    ...rest
}) => {
    const [openSelected, setOpenSelected] = useState(false);

    useEffect(() => {
        setOpenSelected(open);
    }, [open]);

    let selectClassName = `tdt-select tdt-select-${selectStyle} tdt-select-${selectSize} `;
    let tdtDropdownClassName = `tdt-dropdown tdt-dropdown-select-${selectStyle} `;
    let iconSize = 24;
    if (selectSize === 'small') {
        iconSize = 16;
    } else if (selectSize === 'big') {
        iconSize = 32;
    }

    if (className) {
        selectClassName += className;
    }
    if (dropdownSuffix) {
        tdtDropdownClassName += 'tdt-dropdown-has-suffix ';
    }
    if (dropdownClassName) {
        tdtDropdownClassName += dropdownClassName;
    }

    if (dropdownInnerStyle) {
        tdtDropdownClassName += `ovr-dropdown-inner `;
    }

    // width auto
    if (dropdownAutoWidth) {
        tdtDropdownClassName += ` ovr-dropdown-width-auto `;
    }

    let props = {};

    if (suffixIcon) {
        props.suffixIcon = suffixIcon;
    } else {
        props.suffixIcon = (
            <ArrowDropDownIcon
                onClick={() => {
                    setOpenSelected(!openSelected);
                    if (onDropdownVisibleChange) {
                        onDropdownVisibleChange(!openSelected);
                    }
                }}
                size={iconSize}
            />
        );
    }

    return (
        <Select
            {...rest}
            className={selectClassName}
            dropdownClassName={tdtDropdownClassName}
            open={openSelected}
            onDropdownVisibleChange={setOpenSelected}
            dropdownRender={
                dropdownRender
                    ? dropdownRender
                    : menu => (
                          <div style={dropdownInnerStyle}>
                              {menu}
                              {dropdownSuffix && <div className="p-8 m-0">{dropdownSuffix}</div>}
                          </div>
                      )
            }
            notFoundContent={notFoundContent ? notFoundContent : <div style={{ display: 'none' }} />}
            virtual={false}
            {...props}
            autoComplete="new-password"
        >
            {children}
        </Select>
    );
};

export default TdtSelect;

TdtSelect.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    compact: PropTypes.bool,
    selectSize: PropTypes.oneOf(SelectSizes),
    selectStyle: PropTypes.oneOf(SelectStyles),
    suffixIcon: PropTypes.any,
    dropdownRender: PropTypes.func,
    notFoundContent: PropTypes.any,
    dropdownSuffix: PropTypes.any,
    dropdownClassName: PropTypes.string,
    open: PropTypes.bool,
    onDropdownVisibleChange: PropTypes.func,
    dropdownInnerStyle: PropTypes.any,
    dropdownAutoWidth: PropTypes.bool,
};

TdtSelect.defaultProps = {
    selectSize: 'medium',
    selectStyle: 'default',
};
